// Service for handling map interaction logic and hooks

import { useState, useCallback } from 'react';

// Hook for managing map point selection callbacks
export const useMapPointSelect = () => {
  const [mapPointSelectCallback, setMapPointSelectCallback] = useState(null);
  
  // Set callback with validation
  const setMapPointSelect = useCallback((callback) => {

    // Validate callback type
    if (callback !== null && typeof callback !== 'function') {
      console.error(`Invalid callback type: ${typeof callback}. Must be function or null.`);
      return;
    }
    
    setMapPointSelectCallback(() => callback);

  }, []);
  
  // Clear the callback
  const clearMapPointSelect = useCallback(() => {

    setMapPointSelectCallback(null);
  }, []);
  
  return {
    mapPointSelectCallback,
    setMapPointSelect,
    clearMapPointSelect
  };
};

// Check if current mode allows map click to add points
 
export const isMapClickAddPointEnabled = (currentMode, setupSubmode) => {
  return currentMode === 'Setup Path Points' && setupSubmode === 'Map Point Marking';
};

//Check if current mode allows selecting existing points

export const isPointSelectionEnabled = (currentMode) => {
  return currentMode === 'Custom Path' || currentMode === 'Connection Mode';
}; 